import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Button } from '@smartplatform/ui';
import moment from 'moment';
import XLSX from 'xlsx';
import format from 'date-fns/format';
import store from 'client/store';

@observer
export default class ExportPollResults extends React.Component {
	@observable loading = false;

	constructor(props) {
		super(props);
		this.poll = props.poll;
		this.excelData = props.excelData;
	}

	getUsername = (id) => {
		const user = this.users.find((user) => user.id === id);
		return user ? user.firstName ? `${user.lastName} ${user.firstName} ${user.middleName}` : user.username : 'user';
	}

	exportData = async () => {
		this.loading = true;
		this.users =  await store.model.User.find();
		const wb = XLSX.utils.book_new();

		const newTableFields = this.excelData.map((field) => {
		  return {
		  	'Дата': format(new Date(field.createdAt), 'dd.MM.yyyy'),
				'Имя пользователя': field.owner,
				'Вариант ответа': field.label
			}
		});

		const ws2 = XLSX.utils.json_to_sheet([{ A: 'Название опроса', B: this.poll.name }], { skipHeader: true });
		XLSX.utils.sheet_add_json(ws2, [...newTableFields], { origin: 'A4' });
		ws2['!cols'] = [{ wch: 40 }, { wch: 50 }, { wch: 40 }, { "hidden": true }];
		XLSX.utils.book_append_sheet(wb, ws2, 'Основная таблица голосования');

		const fields = this.poll.fields();
		const fieldsData = fields.map(field => {
			const votes = field.votes();
			const totalVotes = votes.length;
			const yes = votes.filter(v => v.answer === '1').length;
			const no = votes.filter(v => v.answer === '2').length;
			const notAnswered = votes.filter(v => v.answer === '0').length;
			const custom = votes.filter(v => v.answer !== '1' && v.answer !== '0' && v.answer !== '2').length;
			return {
				Вопрос: field.name || 'Пользовательский',
				За: yes,
				Против: no,
				'Нет ответа': notAnswered,
				'Свой вариант': custom,
				Всего: totalVotes,
			};
		});

		const ws = XLSX.utils.json_to_sheet([{ A: 'Название опроса', B: this.poll.name }], { skipHeader: true });
		XLSX.utils.sheet_add_json(ws, [...fieldsData], { origin: 'A4' });
		ws['!cols'] = [{ wch: 60 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
		XLSX.utils.book_append_sheet(wb, ws, 'Голосование');

		fields.forEach(field => {
			const columns = [['ФИО', 'IP', 'Дата учасния в опросе', 'Email', 'Кнтактный телефон', 'Ответ']];
			const ws = XLSX.utils.aoa_to_sheet(columns);
			ws['!cols'] = [{ wch: 60 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }];

			field.votes().forEach(vote => {
				const { name, ip, createdAt, email, phone, answer, ownerId } = vote;
				const username = ownerId ? this.getUsername(ownerId) : name;
				XLSX.utils.sheet_add_aoa(
					ws,
					[[username, ip, moment(createdAt).format('LLL'), email || '-', phone || '-', answer || '-']],
					{
						origin: -1,
					}
				);
			});

			XLSX.utils.book_append_sheet(wb, ws, field.name);
		});
		this.loading = false;
		XLSX.writeFile(wb, 'Голосование.xlsx');
	};

	render() {
		return (
			<div>
				{!this.loading ? (
					<Button label="Экспортировать данные в Excel" onClick={this.exportData} />
				) : (
					<p> Готовлю данные к эксорту</p>
				)}
			</div>
		);
	}
}
